import _regeneratorRuntime from 'babel-runtime/regenerator';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Geocode from "react-geocode";
// import Switch from '@material-ui/core/Switch';
// import FormGroup from '@material-ui/core/FormGroup';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
import ExploreIcon from '@material-ui/icons/Explore';
import config from '../../../../config';

var LayerRegionsContent = function (_Component) {
  _inherits(LayerRegionsContent, _Component);

  function LayerRegionsContent(props) {
    _classCallCheck(this, LayerRegionsContent);

    var _this = _possibleConstructorReturn(this, (LayerRegionsContent.__proto__ || Object.getPrototypeOf(LayerRegionsContent)).call(this, props));

    _this.componentDidMount = function () {
      var latLng = _this.calcularCentroYZoom(_this.props.regionContent.vertices);
      _this.setState({
        latLng: latLng
      });
    };

    _this.handleOnclickPoi = function (id) {
      setTimeout(function () {
        _this.setState({
          withOutGroupPoiOpen: id
        });
      }, 100);
    };

    _this.state = {
      stateClass: '',
      stateIconClass: '',
      label: '',
      valueFilter: '',
      address: undefined,
      isOpen: false,
      isFollowDevice: false,
      poiOpen: "",
      withOutGroupPoiOpen: "",
      latLng: {}
    };
    return _this;
  }

  _createClass(LayerRegionsContent, [{
    key: 'getAddress',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(lat, lng) {
        var address, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(lat !== 0)) {
                  _context.next = 14;
                  break;
                }

                lat = lat.toString();
                lng = lng.toString();

                _context.next = 5;
                return fetch(config.URL + ('maps?lat=' + lat + '&lon=' + lng));

              case 5:
                address = _context.sent;

                if (!address.ok) {
                  _context.next = 13;
                  break;
                }

                _context.next = 9;
                return address.text();

              case 9:
                response = _context.sent;
                return _context.abrupt('return', response);

              case 13:
                alert("HTTP-Error: " + address.status);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAddress(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return getAddress;
    }()
  }, {
    key: 'calc',
    value: function calc(num) {
      if (num !== undefined) {
        var with6Decimals = num.toString().match(/^-?\d+(?:\.\d{0,4})?/)[0];
        return with6Decimals;
      }
    }
  }, {
    key: 'calcularCentroYZoom',
    value: function calcularCentroYZoom(posiciones) {
      if (posiciones.length === 0) {
        return { centro: null, zoom: 10 }; // Valor de zoom predeterminado si no hay posiciones
      }

      // Inicializar sumas y extremos
      var sumaLatitud = 0;
      var sumaLongitud = 0;
      var minLatitud = posiciones[0].latitud;
      var maxLatitud = posiciones[0].latitud;
      var minLongitud = posiciones[0].longitud;
      var maxLongitud = posiciones[0].longitud;

      // Calcular sumas y extremos
      posiciones.forEach(function (posicion) {
        sumaLatitud += posicion.latitud;
        sumaLongitud += posicion.longitud;

        minLatitud = Math.min(minLatitud, posicion.latitud);
        maxLatitud = Math.max(maxLatitud, posicion.latitud);
        minLongitud = Math.min(minLongitud, posicion.longitud);
        maxLongitud = Math.max(maxLongitud, posicion.longitud);
      });

      // Calcular centro
      var centroLatitud = sumaLatitud / posiciones.length;
      var centroLongitud = sumaLongitud / posiciones.length;
      var centro = { latitud: centroLatitud, longitud: centroLongitud };

      // Calcular zoom en función del tamaño de la región
      var latitudDelta = maxLatitud - minLatitud;
      var longitudDelta = maxLongitud - minLongitud;
      var maxDelta = Math.max(latitudDelta, longitudDelta);
      var zoom = Math.floor(10 - Math.log2(maxDelta));

      return { centro: centro, zoom: zoom };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classNameCollapse = "";
      if (this.state.withOutGroupPoiOpen !== undefined) {
        if (this.state.withOutGroupPoiOpen === this.props.regionContent.idRegion) {
          classNameCollapse = "collapse show";
        } else {
          classNameCollapse = "collapse";
        }
      }

      return React.createElement(
        'div',
        { className: 'panel-body', id: 'accordion1' },
        React.createElement(
          'div',
          { className: 'panel-group' },
          React.createElement(
            'div',
            { className: 'panel panel-default sub-group-content sub-group-1', onClick: this.handleOnclickPoi.bind(this, this.props.regionContent.idRegion) },
            React.createElement(
              'label',
              { 'class': 'containerCheck', style: { position: "absolute", marginTop: "8px", marginLeft: "12px" } },
              React.createElement('input', { type: 'checkbox', onChange: function onChange() {
                  return _this2.props.handleCheckboxRegionChange(_this2.props.regionContent.idRegion, true);
                },
                checked: this.props.regionContent.isChecked }),
              React.createElement('span', { style: { marginTop: "0px" }, 'class': 'checkmark' })
            ),
            React.createElement(
              'a',
              { 'data-toggle': 'collapse', 'data-parent': '#accordion',
                href: "#group-1-level-223Poi__" + this.props.regionContent.idRegion },
              React.createElement(
                'div',
                { className: 'panel-heading map-content-level2' },
                React.createElement(
                  'div',
                  { className: 'panel-title' },
                  React.createElement(
                    'div',
                    { className: 'level2-heading' },
                    React.createElement(
                      'div',
                      { className: 'level2-heading-left' },
                      React.createElement('span', { className: "bg-left " + this.state.stateClass }),
                      React.createElement('span', { className: this.state.stateIconClass }),
                      React.createElement(
                        'span',
                        { className: 'trackerName', style: { marginLeft: 20 } },
                        this.props.regionContent.nombreRegion
                      )
                    )
                  )
                )
              )
            ),
            React.createElement('div', { className: 'clearfix' }),
            React.createElement(
              'div',
              { id: "group-1-level-223Poi__" + this.props.regionContent.idRegion, className: classNameCollapse },
              React.createElement(
                'div',
                { className: 'panel-body level2-content' },
                React.createElement(
                  'div',
                  { className: 'level2-content-top' },
                  React.createElement(
                    'div',
                    { className: 'level2-content-top-inner clearfix' },
                    React.createElement(
                      'ul',
                      { className: 'level2-driver-details list-unstyled' },
                      React.createElement(
                        'li',
                        null,
                        'V\xE9rtices: ',
                        this.props.regionContent.vertices.length
                      )
                    ),
                    React.createElement(
                      'ul',
                      { className: 'level2-driving-details list-unstyled' },
                      this.state.latLng.centro !== undefined && React.createElement(
                        'li',
                        null,
                        React.createElement(ExploreIcon, { style: { color: "#575756", marginTop: "5px", cursor: "pointer" },
                          onClick: this.props.centerMap.bind(this, this.state.latLng.centro.latitud, this.state.latLng.centro.longitud, this.state.latLng.zoom) })
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LayerRegionsContent;
}(Component);

export default LayerRegionsContent;